import { requireAuth } from '@/router/helpers';

export default [
  // Systems -> All
  {
    path: '/system-status',
    name: 'SystemStatus',
    component: () => import('@/views/SystemStatus'),
    beforeEnter: requireAuth,
    props: { tabFilter: 'all' },
  },

  {
    path: '/system-status/:id/status',
    name: 'ViewStatus',
    components: {
      default: () => import('@/views/SystemStatus'),
      panel: () => import('@/views/ViewSystemStatus'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
    },
  },

  // Systems -> Following
  {
    path: '/system-status/following',
    name: 'SystemStatusFollowing',
    component: () => import('@/views/SystemStatus'),
    beforeEnter: requireAuth,
    props: { tabFilter: 'following' },
  },

  // Systems -> Create
  {
    path: '/admin/system-status/add',
    name: 'AdminAddSystem',
    components: {
      default: () => import('@/views/SystemStatus'),
      panel: () => import('@/views/SystemStatusAdd'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },
  {
    path: '/admin/system-status/:id',
    name: 'AdminEditSystem',
    components: {
      default: () => import('@/views/SystemStatus'),
      panel: () => import('@/views/SystemStatusAdd'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },
  {
    path: '/admin/system-status',
    name: 'AdminSystemStatus',
    component: () => import('@/views/SystemStatus'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  // Systems -> Edit
  {
    path: '/admin/system-status/:id/update',
    name: 'AdminUpdateStatus',
    components: {
      default: () => import('@/views/SystemStatus'),
      panel: () => import('@/views/SystemStatusUpdate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  // external systems
  {
    path: '/external-systems',
    name: 'ExternalSystems',
    component: () => import('@/views/ExternalSystems'),
    beforeEnter: requireAuth,
    meta: { isAdmin: false },
  },
  {
    path: '/admin/external-systems',
    name: 'AdminExternalSystems',
    component: () => import('@/views/ExternalSystems'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/external-systems/add',
    name: 'AdminAddExternalSystem',
    components: {
      default: () => import('@/views/ExternalSystems'),
      panel: () => import('@/views/ExternalSystemAddEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },
  {
    path: '/admin/external-systems/:id/edit',
    name: 'AdminEditExternalSystem',
    components: {
      default: () => import('@/views/ExternalSystems'),
      panel: () => import('@/views/ExternalSystemAddEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },
];
